<template>
  <div class="sidebar">
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse"
      text-color="#000000" active-text-color="#006DBE" unique-opened router>
      <template v-for="menu in menus">
      <!-- <template v-for="menu in this.$parent.subMenus"> -->
        <template v-if="menu.children">
          <el-submenu :index="menu.resourcename" :key="menu.resourcename">
            <template slot="title">
              <i :class="getMenuIcon(menu.icon)"></i>
              <span>&nbsp;{{menu.resourceinfo}}</span>
            </template>
            <el-menu-item v-for="(child, childIndex) in menu.children" :key="childIndex" :index="child.resourcename">
              {{child.resourceinfo}}
              <!--<router-link :to="children.path">{{children.meta.title}}</router-link>-->
            </el-menu-item>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="menu.resourcename" :key="menu.resourcename">
            <i :class="getMenuIcon(menu.icon)"></i>
            <span>&nbsp;{{menu.resourceinfo}}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from "../../../common/js/bus";
import { mapMutations } from "vuex";
export default {
  name: "AsideDom",
  data() {
    return {
      collapse: false,
      isCollapse: false,
      isUniqueOpened: true,
      isRouter: true,
      menus: [],
      tzggMenus:[]
    };
  },
  methods: {
    //初始化菜单
    initMenu() {
      let vm = this;
      vm.$axios.get("/resource/menuTree").then(function(res) {
          vm.menus = res.data.result;
        }.bind(this),function(error) {
          console.log(error);
        }
      );
    },
    getMenuIcon(value) {
      return "iconfont " + value;
    }
  },
  watch:{
    $route(to, from){
      var toPath = to.path;
      var fromPath = from.path;
      if(toPath.split("/")[1] != fromPath.split("/")[1]){
        if(this.$route.matched.length > 2){
          this.initMenu(this.$route.matched[1].path);
        }else{
          this.initMenu(to.path);
        }
      }else{
        if(toPath.split("/").length == 2){
          let path = this.menus[0].resourcename;
          if(this.menus.length > 0){
            if(this.menus[0].children!=null && this.menus[0].children.length>0){
              path = this.menus[0].children[0].resourcename;
            }
          }
          this.$router.replace({ path : path });
        }
      }
      //清除store中listPagePars add by li.xue 2020/12/15
      let toMatched = to.matched[1].path;
      let fromMatched = from.matched[1].path;
      if((toMatched.endsWith('/')?toMatched.substr(0,toMatched.length-1):toMatched) 
        != (fromMatched.endsWith('/')?fromMatched.substr(0,fromMatched.length-1):fromMatched)){
        if(Object.keys(this.$store.state.listPagePars).length > 0){
          this.$store.commit('RESET_LIST_PAGE_PERS');
        }
      }
    }
  },
  mounted() {
    this.initMenu();
  },
  computed: {
    onRoutes() {
      // var subMenus = this.$parent.subMenus;
      var subMenus = this.menus;
      var routePath = this.$route.path;
      if(this.$route.matched.length > 3){
        routePath = this.$route.matched[2].path;
      }else if(this.$route.matched.length == 3 && !this.$route.matched[2].path.endsWith('/')){
        routePath = this.$route.matched[1].path;
      }
      if(routePath.endsWith('/')){
        routePath = routePath.substr(0, routePath.length-1);
      }
      for(var i in subMenus){
        if(routePath == subMenus[i].resourcename){
          this.subMenus = subMenus[i].children;
        }else{
          if(subMenus[i].children != null){
            for(var j in subMenus[i].children){
              if(routePath == subMenus[i].children[j].resourcename){
                this.subMenus = subMenus[i].children;
              }
            }
          }
        }
        return routePath;
      }

      /**页面为子页面时，选中其父菜单 by li.xue 2019/3/13
        var routeMatched = [];
        var defaultActive = '';
        routeMatched = this.$route.matched
        for (var i in routeMatched) {
          if (routeMatched[i].meta.title) {
            defaultActive = routeMatched[i].path;
            break;
          }
        }
        return defaultActive;
        */
    }
  },
  created() {
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on("collapse", msg => {
      this.collapse = msg;
    });
  }
};
</script>

<style scoped lang="scss">
@import "../../../common/scss/mixin.scss";
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 60px;
  bottom: 0;
  // background: red;
  //   background-image: url("/static/images/login/menu_bg1.png");
  // background-size: 100% 100%;
  // background-repeat: no-repeat;
  // background-position: ;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu {
    overflow-y: scroll;

  height: 100%;
  // background-color: #025CA4;
  background-color: #EEEEEE;
  // background-image: url("/static/images/login/menu_bg1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position:bottom ;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 240px;
}
.sidebar > ul {
  height: 100%;
}
.el-menu-item i {
  /*color: #961617;*/
  @include font-color($color-active);
  color: #026EB6;
}
.el-submenu__title i {
  // @include font-color($color-active);
  color: #026EB6;
}
.el-submenu {
  border-bottom: 1px solid #e1e4f5;
}
.el-menu-item {
  @include font-color($color-active);
  border-bottom: 1px solid #e1e4f5;
}
.el-menu--collapse > .el-menu-item.is-active i {
  /*color: #961617;*/
  @include font-color($color-active);
}
.el-menu-item.is-active{
  background-color: #ecf5ff;
  font-weight: 600;
  // @include font-color($color-active);
}
.el-menu-item:hover {
  background-color: #ecf5ff !important;
}
.el-submenu__title:hover {
  background-color: #ecf5ff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/common/layout/AsideDom.vue